// src/App.js
import React, { Component, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation, Link } from "react-router-dom";
import Navbar from "./components/Navbar";
// import ChatWidget from "./components/ChatWidget";
import WhatsAppButton from "./components/WhatsAppButton";
import Dashboard from "./pages/Dashboard";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import VerifyOtp from "./components/VerifyOtp";
import ResetPassword from "./components/ResetPassword";
import ResidentialRental from "./components/ResidentialRental";
import ProtectedRoute from "./components/ProtectedRoute";
import FilterPage from "./components/FilterPage";
import Footer from "./components/Footer";
import PaymentStatusPage from "./components/PaymentStatusPage";
import SavedProperties from "./components/SavedProperties";
import GeotagPhotos from "./pages/GeotagPhotos";
import VerifyListingLanding from "./pages/VerifyListingLanding";
import PremiumClubLeadsAdmin from "./pages/PremiumClubLeadsAdmin";
import Profile, { handleSaveProfilePermission } from "./components/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndCondition from "./components/TermsAndCondition";
import Disclaimer from "./components/Disclaimer";
import AboutUs from "./components/About-us";
import ContactUs from "./components/ContactUs";
import List from "./components/List";
import PropertyListed from "./components/PropertyListed";
import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';
import {
  requestNotificationPermission,
  onMessageListener,
  isNotificationSupported,
  areNotificationsBlocked,
  getNotificationInstructions, getNotificationPermission
} from './firebase';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import apiClient from './common/apiClient';
import decryptResponse from './common/decrypt';
import MyProperty from "./components/Myproperty";
import BrokerProfile from "./components/BrokerProfile";
import BuilderCard from "./components/BuilderCard";
import MatchProperty from "./components/MatchProperty";
import SavedSearches from "./components/SavedSearches";
import { Toaster } from "react-hot-toast";
import LocationTracker from "./components/LocationTracker"
import MetaPixelRouteTracker from "./components/MetaPixelRouteTracker";
import RefundPolicy from "./components/RefundPolicy";
import BrokerCodeOfConduct from "./components/BrokerCodeOfConduct";
import ContentTakedownPolicy from "./components/ContentTakedownPolicy";
import TermsOfService from "./components/TermsAndCondition";
import Index from "./pages/Index";
import DashboardLayout from "./layouts/DashboardLayout";
import OwnerProperties from "./pages/OwnerProperties";
import BrokerB2B from "./pages/BrokerB2B";
// import StaffManagement from "./pages/StaffManagement";
import Subscription from "./pages/Subscription";
import { LanguageProvider } from "./contexts/LanguageContext";
import { UserProfileProvider, useUserProfile } from "./contexts/UserProfileContext";
import StaffManagement from "./pages/StaffManagement";
import Ownerdashboard from "./pages/Ownerdashboard";
import OwnerLogin from "./components/Ownerdashboard/OwnerLogin";
import OwnerProtectedRoute from "./components/Ownerdashboard/OwnerProtectedRoute";
import ExpriedPopup from "./components/ExpriedPopup";
import PremiumRequiredPopup from "./components/PremiumRequiredPopup";
import SessionExpiredPopup, { showSessionExpiredPopup } from "./components/SessionExpiredPopup";
import ContactCreditsPopup, { buildContactCreditsPopupData } from "./components/ContactCreditsPopup";
import DemoPlanPopup from "./components/DemoPlanPopup";
import { DemoAccount } from "./constants/feature.constants";

// Session checking component that runs on every route change
let lastSessionCheck = 0;

// Contact Credits Popup Checker - shows popup when plan credits are low
let contactCreditsPopupShown = false;
let contactCreditsPopupFetchInFlight = false;

// Demo plan popup - shows a short popup for demo accounts
let demoPlanPopupShown = false;
let demoPlanPopupFetchInFlight = false;

const getDemoPlanPopupDismissKey = (userId) => `demoPlanPopupDismissed:${userId || "anonymous"}`;

const DemoPlanChecker = () => {
  const location = useLocation();
  const [showDemoPlanPopup, setShowDemoPlanPopup] = useState(false);
  const [demoPlanData, setDemoPlanData] = useState(null);

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");
    const dismissKey = getDemoPlanPopupDismissKey(userId);
    const protectedRoutes = ["/dashboard"];

    if (
      !token ||
      !userId ||
      demoPlanPopupShown ||
      demoPlanPopupFetchInFlight ||
      !protectedRoutes.includes(location.pathname) ||
      localStorage.getItem(dismissKey) === "true"
    ) {
      return;
    }

    const checkDemoPlan = async () => {
      demoPlanPopupFetchInFlight = true;
      try {
        const response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/dsvsdv/v2/casadyt/${userId}/csauyv`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        let finalData = response?.data?.data || {};

        if (response?.error?.encrypted) {
          const decrypted = decryptResponse(response.error.encrypted);
          if (decrypted) {
            finalData = decrypted;
          }
        }

        const planName =
          finalData?.plan ||
          finalData?.PlanName ||
          finalData?.planName ||
          finalData?.DemoAccount?.[0]?.PlanName ||
          finalData?.DemoAccount?.[0]?.planName ||
          finalData?.user?.plan ||
          finalData?.user?.planName ||
          "";

        const isDemoAccount = String(planName).trim().toLowerCase() === String(DemoAccount.DEMO_ACCOUNT).trim().toLowerCase();

        if (isDemoAccount) {
          setDemoPlanData(finalData);
          setShowDemoPlanPopup(true);
          demoPlanPopupShown = true;
        }
      } catch (error) {
        console.error("Error checking demo plan:", error);
      } finally {
        demoPlanPopupFetchInFlight = false;
      }
    };

    checkDemoPlan();
  }, [location.pathname]);

  const handleCloseDemoPopup = () => {
    const userId = Cookies.get("userId");
    localStorage.setItem(getDemoPlanPopupDismissKey(userId), "true");
    setShowDemoPlanPopup(false);
    window.dispatchEvent(new Event("demo-plan-popup-dismissed"));
  };

  return (
    <DemoPlanPopup
      isOpen={showDemoPlanPopup}
      onClose={handleCloseDemoPopup}
      demoPlanData={demoPlanData}
    />
  );
};

const ContactCreditsChecker = () => {
  const location = useLocation();
  const [showContactCreditsPopup, setShowContactCreditsPopup] = useState(false);
  const [contactCreditsPopupData, setContactCreditsPopupData] = useState(null);

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");
    const protectedRoutes = ['/dashboard'];

    if (
      !token ||
      !userId ||
      contactCreditsPopupShown ||
      contactCreditsPopupFetchInFlight ||
      !protectedRoutes.includes(location.pathname)
    ) {
      return;
    }

    const checkContactCredits = async () => {
      contactCreditsPopupFetchInFlight = true;
      try {
        const response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/dsvsdv/v2/casadyt/${userId}/csauyv`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        let finalData = response?.data?.data || {};

        // Check if it's encrypted
        if (response?.error?.encrypted) {
          const decrypted = decryptResponse(response.error.encrypted);
          if (decrypted) {
            finalData = decrypted;
          }
        }

        // Check if plan or features are expired - if so, skip contact credits popup
        const featuresAccessData = Array.isArray(finalData?.FeaturesAccessData) ? finalData.FeaturesAccessData : [];
        const normalizeStatus = (value) => String(value || "").trim().toLowerCase();
        const hasExpiredFeatures = featuresAccessData.some(
          (feature) => normalizeStatus(feature?.status) === "expired" || normalizeStatus(feature?.status) === "expried"
        );

        if (hasExpiredFeatures) {
          // Plan is expired, don't show contact credits popup
          contactCreditsPopupFetchInFlight = false;
          return;
        }

        const planName =
          finalData?.plan ||
          finalData?.PlanName ||
          finalData?.planName ||
          finalData?.DemoAccount?.[0]?.PlanName ||
          finalData?.DemoAccount?.[0]?.planName ||
          finalData?.user?.plan ||
          finalData?.user?.planName ||
          "";

        const normalizedPlanName = String(planName).trim().toLowerCase();
        const isDemoAccount = normalizedPlanName === String(DemoAccount.DEMO_ACCOUNT).trim().toLowerCase();

        // Avoid showing both popups at once. If DemoPlanPopup is about to show or already shown,
        // we skip the credit warning for this specific check.
        const dismissKey = getDemoPlanPopupDismissKey(userId);
        const isDemoDismissed = localStorage.getItem(dismissKey) === "true";

        if (isDemoAccount && !isDemoDismissed) {
          contactCreditsPopupFetchInFlight = false;
          return;
        }

        const popupData = buildContactCreditsPopupData(finalData, {
          demoThreshold: 10,
          standardThreshold: 100,
        });

        if (popupData) {
          setContactCreditsPopupData(popupData);
          setShowContactCreditsPopup(true);
          contactCreditsPopupShown = true;
          localStorage.removeItem("justLoggedIn");
        }
      } catch (error) {
        console.error("Error checking contact credits:", error);
      } finally {
        contactCreditsPopupFetchInFlight = false;
      }
    };

    checkContactCredits();
  }, [location.pathname]);

  return (
    <ContactCreditsPopup
      isOpen={showContactCreditsPopup}
      onClose={() => setShowContactCreditsPopup(false)}
      popupData={contactCreditsPopupData}
    />
  );
};

const SessionChecker = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fetchUserProfile } = useUserProfile();

  const checkSession = async () => {
    const now = Date.now();
    if (now - lastSessionCheck < 5000) return; // Don't check more than once every 5 seconds
    lastSessionCheck = now;

    try {
      const token = Cookies.get("token");
      if (!token) {
        // console.error("No authentication token found");
        return;
      }

      const sessionResponse = await apiClient(
        "get",
        "/cjidnvij/ceksfbuebijn/user/v2/checkSession",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      let finalData = sessionResponse;

      // 🔑 Decrypt agar encrypted response hai
      if (sessionResponse?.error?.encrypted) {
        const decrypted = decryptResponse(sessionResponse.error.encrypted);
        if (decrypted) {
          finalData = decrypted;
        } else {
          // console.error("❌ Failed to decrypt response");
        }
      }

      // console.log("Session check response (decrypted):", finalData);

      // 🔹 Error handling after decryption
      if (
        finalData.success === false ||     // pehle wala condition
        finalData.status === "error" ||    // naya condition add
        finalData.status === 401          // explicitly check for 401
      ) {
        // ✅ direct action root-level
        if (finalData.action === "logout" || finalData.status === 401) {
          handleLogout(finalData.message || "Session expired");
        }
        // ✅ fallback agar error object ke andar hai
        else if (finalData.error?.action === "logout") {
          handleLogout(finalData.error.message || "Session expired");
        }
      }

    } catch (error) {
      // console.error("Error checking session:", error);
    }
  };

  const handleLogout = (message) => {
    Cookies.remove("token");
    Cookies.remove("userId");
    Cookies.remove("isPremium");
    Cookies.remove("deviceId");
    localStorage.clear();
    navigate("/login");
    showSessionExpiredPopup(message);
  };

  // Check session whenever location changes (user navigates to different component)
  useEffect(() => {
    // Only check session for protected routes
    const protectedRoutes = ['/dashboard', '/owner-properties', '/broker-properties', '/filter', '/residential-rental', '/saved-properties', '/my-profile', '/payment-success', '/property-listed' , '/residential-rental/builder', '/verify-listing'];
    if (protectedRoutes.includes(location.pathname)) {
      checkSession();
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

const AppContent = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [notificationPermission, setNotificationPermission] = useState(null);
  const [showNotificationBlockedAlert, setShowNotificationBlockedAlert] = useState(false);
  const [showPermissionPopup, setShowPermissionPopup] = useState(false);
  const [isPermissionAccepted, setIsPermissionAccepted] = useState(false);
  const [showExpriedPopup, setShowExpriedPopup] = useState(false);
  const [expiredFeatures, setExpiredFeatures] = useState([]);
  const [expiredPopupChecked, setExpiredPopupChecked] = useState(false);

  useEffect(() => {
    const isPopupDismissed = localStorage.getItem("popupDismissed");
    const isAddedToHomeScreen = localStorage.getItem("addedToHomeScreen");
    const token = Cookies.get("token");

    // Only show popup if user is logged in and popup hasn't been dismissed
    if (token && !isPopupDismissed && !isAddedToHomeScreen) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }

    const beforeInstallPromptListener = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    // Listen for when app is installed
    const appInstalledListener = () => {
      // console.log("PWA was installed");
      localStorage.setItem("addedToHomeScreen", "true");
      setShowPopup(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", beforeInstallPromptListener);
    window.addEventListener("appinstalled", appInstalledListener);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        beforeInstallPromptListener
      );
      window.removeEventListener("appinstalled", appInstalledListener);
    };
  }, [location.pathname]);

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");
    const permissionCookie = Cookies.get("permission");

    if (token && userId) {
      if (permissionCookie === "true") {
        setIsPermissionAccepted(true);
        setShowPermissionPopup(false);
      } else {
        setIsPermissionAccepted(false);
        setShowPermissionPopup(true);
      }
    } else {
      setIsPermissionAccepted(false);
      setShowPermissionPopup(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    // Initialize notifications
    const initializeNotifications = async () => {
      if (!isNotificationSupported()) {
        // console.log("Notifications are not supported in this browser");
        return;
      }

      if (areNotificationsBlocked()) {
        setShowNotificationBlockedAlert(true);
        return;
      }

      const { token, permission, error, instructions } = await requestNotificationPermission();

      if (token) {
        // console.log("FCM Token:", token);
        // Store this token in the backend so push notifications can reach
        // this device. Only if logged in -- a token with no userId is
        // useless to us. Fire-and-forget, never blocks the UI.
        const userId = Cookies.get('userId');
        if (userId) {
          apiClient(
            'post',
            '/ijscui/probroker-admin/ceknvuhbd/Notifications/protected/register-token',
            { userId, token }
          ).catch(() => {});
        }

        logEvent(analytics, 'notification_permission', {
          status: 'granted'
        });
      } else if (error === 'notifications-blocked') {
        setShowNotificationBlockedAlert(true);

      } else if (error) {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      setNotificationPermission(permission);
    };

    initializeNotifications();

    // Set up message listener
    const unsubscribe = onMessageListener()
      .then((payload) => {
        // console.log("Received foreground message:", payload);
        if (!payload) return; // messaging unsupported (e.g. localhost)

        // Show a toast notification
        toast.info(payload.notification?.body || "New notification received", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Log the event
        logEvent(analytics, 'notification_received', {
          notification_type: payload.notification?.title || 'unknown'
        });
      })
      .catch((err) => {
        // console.error("Failed to receive message:", err);
        logEvent(analytics, 'notification_error', {
          error: err.message
        });
      });

    return () => {
      // Cleanup if needed
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  useEffect(() => {
    const checkExpiredFeatures = async () => {
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");
      
      if (!token || !userId || expiredPopupChecked) {
        return;
      }

      try {
        const response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/dsvsdv/v2/casadyt/${userId}/csauyv`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = response?.data?.data || {};
        const featuresAccessData = Array.isArray(data?.FeaturesAccessData)
          ? data.FeaturesAccessData
          : [];

        const normalizeStatus = (value) => String(value || "").trim().toLowerCase();

        const hasActiveFeature = featuresAccessData.some(
          (feature) => normalizeStatus(feature?.status) === "active"
        );

        const expiredItems = featuresAccessData.filter((feature) => {
          const status = normalizeStatus(feature?.status);
          return status === "expried" || status === "expired";
        });

        // Show popup only when there are expired items and no active items.
        if (expiredItems.length > 0 && !hasActiveFeature) {
          setExpiredFeatures(expiredItems);
          setShowExpriedPopup(true);
        }
      } catch (error) {
        console.error("Error checking expired features:", error);
      } finally {
        setExpiredPopupChecked(true);
      }
    };

    checkExpiredFeatures();
  }, [location.pathname, expiredPopupChecked]);

  const handleAddToHomeScreen = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          logEvent(analytics, 'add_to_home_screen', {
            outcome: 'accepted'
          });
          localStorage.setItem("addedToHomeScreen", "true");
          setShowPopup(false);
        } else {
          logEvent(analytics, 'add_to_home_screen', {
            outcome: 'rejected'
          });
        }
        setDeferredPrompt(null);
      });
    }
  };

  const handleDismissPopup = () => {
    setShowPopup(false);
    localStorage.setItem("popupDismissed", "true"); // Mark the popup as dismissed
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
        }}
      />

      {/* <Navbar /> */}
      {/* <ChatWidget /> */}
      <WhatsAppButton />
      <SessionChecker />
      <DemoPlanChecker />
      <ContactCreditsChecker />
      <LocationTracker />
      <MetaPixelRouteTracker />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/get-listing-verified" element={<VerifyListingLanding />} />
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} />} />
          <Route path="/owner-properties" element={<ProtectedRoute element={OwnerProperties} />} />
          <Route path="/broker-properties" element={<ProtectedRoute element={BrokerB2B} />} />
          <Route
            path="/residential-rental/:type?"
            element={<ProtectedRoute element={ResidentialRental} />}
          />

          <Route
            path="/saved-properties"
            element={<ProtectedRoute element={SavedProperties} />}
          />
      <Route
        path="/verify-listing"
        element={<ProtectedRoute element={GeotagPhotos} />}
      />
          <Route
            path="/myproperty"
            element={<ProtectedRoute element={MyProperty} />}
          />
          <Route
            path="/my-profile"
            element={<ProtectedRoute element={Profile} />}
          />
          <Route path="/subscription/*" element={<ProtectedRoute element={Subscription} />} />
          <Route path="/staff" element={<ProtectedRoute element={StaffManagement} />} />
          <Route
            path="/match-property"
            element={<ProtectedRoute element={MatchProperty} />}
          />
          <Route
            path="/saved-searches"
            element={<ProtectedRoute element={SavedSearches} />}
          />
          <Route
            path="/admin/premium-club-leads"
            element={<ProtectedRoute element={PremiumClubLeadsAdmin} />}
          />
        </Route>
        {/* Owner dashboard (OTP based login) */}
        <Route path="/owner/login" element={<OwnerLogin />} />
        <Route
          path="/owner/dashboard"
          element={<OwnerProtectedRoute element={Ownerdashboard} />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgetpassword" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />{" "}
        <Route path="/refund-policy" element={<RefundPolicy />} />{" "}
        <Route path="/broker-code-of-conduct" element={<BrokerCodeOfConduct />} />{" "}
        <Route path="/content-takedown-policy" element={<ContentTakedownPolicy />} />{" "}
        <Route path="/terms-of-service" element={<TermsOfService />} />{" "}
        <Route path="/disclaimer" element={<Disclaimer />} />{" "}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />{" "}
        <Route path="/list" element={<List />} />
        <Route path="/property-listed" element={<PropertyListed />} />

        <Route path="/broker-profile/:bid" element={<BrokerProfile />} />
        <Route path="/builder-card" element={<BuilderCard />} />


        <Route
          path="/filter"
          element={<ProtectedRoute element={FilterPage} />}
        />



        <Route
          path="/payment-success"
          element={<ProtectedRoute element={PaymentStatusPage} />}
        />
        <Route
          path="/list"
          element={<ProtectedRoute element={List} />}
        />

        <Route
          path="/subscription/*"
          element={<ProtectedRoute element={Subscription} />}
        />

      </Routes>
      {/* <Footer /> */}

      {/* {showPopup && (
        <div className="fixed bottom-20 right-4 z-50 flex flex-col items-end gap-2">
          <button
            onClick={handleDismissPopup}
            className="bg-white hover:bg-gray-100 text-gray-600 w-8 h-8 rounded-full shadow-md flex items-center justify-center transition-all duration-200"
            title="Dismiss"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <button
            onClick={handleAddToHomeScreen}
            className="bg-[#503691] hover:bg-[#3f2d7a] text-white px-4 py-3 rounded-full shadow-lg flex items-center gap-2 transition-all duration-200 hover:scale-105"
            title="Install App"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            <span className="font-medium text-sm">Install App</span>
          </button>
        </div>
      )} */}
      {showPermissionPopup && !isPermissionAccepted && (
        <div className="popup-overlay permission-popup-overlay">
          <div className="popup-container permission-popup-container">
            <div className="permission-close-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
            <div className="permission-popup-content">
              <div className="permission-text-block">
                <h2 className="permission-title">Cookie Consent</h2>
                <p className="permission-description">
                  We use cookies and similar technologies to improve your browsing
                  experience, analyze website traffic, and personalize content.
                  By continuing to use this website, you agree to our use of cookies.
                  You can manage your preferences or learn more in our Cookie Policy.{" "}
                  <Link
                    to="/privacy-policy"
                    className="permission-link"
                    onClick={() => setShowPermissionPopup(false)}
                  >
                    Privacy policy
                  </Link>
                </p>
              </div>
              <div className="permission-actions">

                <button
                  className="permission-accept-btn"
                  onClick={async () => {
                    const response = await handleSaveProfilePermission();
                    if (!response || !response.success) {
                      toast.error("Failed to update permission. Please try again.");
                      return;
                    }
                    Cookies.set("permission", "true", { expires: 365 });
                    setIsPermissionAccepted(true);
                    setShowPermissionPopup(false);
                    toast.success("Permission accepted successfully.");
                  }}
                >
                  Accept all
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ExpriedPopup
        show={showExpriedPopup}
        onClose={() => setShowExpriedPopup(false)}
        expiredFeatures={expiredFeatures}
      />

      {/* Opened from anywhere via openPremiumRequiredPopup() */}
      <PremiumRequiredPopup />
      <SessionExpiredPopup />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <LanguageProvider>
        <UserProfileProvider>
          <AppContent />
        </UserProfileProvider>
      </LanguageProvider>
    </Router>
  );
};

export default App;
